import React, {useEffect} from 'react';
import ReactHlsPlayer from 'react-hls-player';
import Hls from 'hls.js';

const supportsHsl = Hls.isSupported();

function VideoSlide({slide, isPlaying}) {
    const playerRef = React.useRef();

    useEffect(() => {
        const video = playerRef.current;
        if (!video) {
            return;
        }

        if (isPlaying) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    // AbortError: play() interrupted by new load/pause
                    // NotAllowedError: autoplay blocked by browser policy
                    if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') {
                        console.error('Video play error:', error);
                    }
                });
            }
        } else {
            video.pause();
        }
    }, [isPlaying]);

    if (!supportsHsl || !slide.playHls) {
        return <video className={'object-contain h-full'} ref={playerRef} loop={true} muted={false}
                      src={slide.shareUrl} />
    }

    return (
        <ReactHlsPlayer className={'object-contain h-full'} controls={true} loop={true} muted={false}
                        playerRef={playerRef} src={slide.url} hlsConfig={{
            xhrSetup: function (xhr, url) {
                xhr.withCredentials = true;
            }
        }} />
    );
}

export default React.memo(VideoSlide);
